<template>
  <li class="node-tree">
    <span class="label hoveredSpan" @click="nodeClick()">
      {{ node.path }}
      <b-badge v-if="node.methods" :variant="badgeVariant">{{settedMethods}} / {{ Object.keys(node.methods).length }} </b-badge>
    </span>
    <span class="hoveredSpan" v-if="node.nodes.length" @click="isOpened = !isOpened" >{{ node.nodes.length? isOpened ? '[-]' : '[+]' :''}}</span>

    <ul v-if="node.nodes && node.nodes.length && isOpened">
      <node @endpointClicked="endpointClicked" v-for="child in node.nodes" :key="child.path" :node="child"></node>
    </ul>
  </li>
</template>

<style>
span.hoveredSpan:hover {
  font-size:1.1rem;
  cursor: pointer;
}
</style>

<script>
export default {
  data () {
    return {
      isOpened: false
    }
  },
  name: 'node',
  props: {
    node: null
  },
  methods: {
    calcuteSettedMethods () {

    },
    endpointClicked (node) {
      this.$emit('endpointClicked', node)
    },
    nodeClick () {
      if (this.node.nodes.length) {
        this.isOpened = !this.isOpened
      }
      if (this.node.endpoint) {
        this.$emit('endpointClicked', this.node)
      }
    }
  },
  computed: {
    badgeVariant () {
      if (this.settedMethods > 0) {
        if (this.settedMethods === this.allMethods) {
          return 'success'
        }
        return 'warning'
      }
      return 'dark'
    },
    allMethods () {
      let tmp = 0
      if (this.node.methods) {
        // eslint-disable-next-line
        for (let key in this.node.methods) {
          ++tmp
        }
      }
      return tmp
    },
    settedMethods () {
      let tmp = 0
      if (this.node.methods) {
        for (let key in this.node.methods) {
          if (this.node.methods[key]) {
            ++tmp
          }
        }
      }
      return tmp
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NodeTree.vue